<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { headlineText, toplineText, toplineType, headlineType, mainText, button, Faqs } = props.content?.data

</script>
<template>
  <section class="relative">
    <div class="container px-0 xl:px-5 relative z-[1]">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-10">
        <div class="lg:pr-4">
          <SharedTopline :headline="toplineText" :headlineType="toplineType"></SharedTopline>
          <SharedHeadline :headline="headlineText" :headlineType="headlineType" class="mb-[1.875rem]"></SharedHeadline>

          <div class="mb-4" v-html="mainText"></div>

          <SharedButton v-if="button"  :button="button" :class="['btn-outline btn-sm', 'w-full', 'sm:w-auto']"></SharedButton>
        </div>
        <div class="prose-p:text-base [&>.group:not(:last-child)]:mb-2.5">
          <template v-for="faq in Faqs">
            <div class="group bg-skin-white rounded p-5 rounded">
              <div class="py-2.5 pr-16 relative cursor-pointer" data-accordian-question="1" @click="faq.active = !faq.active">
                <h4 class="font-bold font-base" v-html="faq.faqTitle"></h4>
                <button type="button" class="h-[1.94rem] w-10 bg-skin-icon rounded-[1.875rem] absolute right-0 top-1/2 -mt-3.5"><i class="inline-block w-full h-full bg-no-repeat bg-accordian bg-[center] group-[&.active]:rotate-180"></i></button>
              </div>
              <div v-if="faq.active" class="pt-4" data-accordian-answer="1">
                <div v-html="faq.faqText"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <img src="/images/layer4.svg" alt="" class="absolute z-0 top-[0px] left-1/4 hidden lg:block">
  </section>
</template>
